export const PREVIEW_EVENT_RANGE_IN_HOURS = 1;
export const IS_PREVIEW_ID = 'IS_PREVIEW';
export const IS_ORIGINAL_PLACEHOLDER_ID = 'IS_ORIGINAL_PLACEHOLDER_ID';
export const DAY_EVENTS = 'DAY_EVENTS';
export const DAY_AVAILABILITIES = 'DAY_AVAILABILITIES';
export const IS_AVAILABILITY_BACKGROUND_PREFIX = 'AVAILABILITY_BG_';
